import './DataTableColumnsListItem.css';
export var columnName = '_13ypmcy2-3-8-0';
export var columnsListItem = '_13ypmcy0-3-8-0';
export var dragging = '_13ypmcy1-3-8-0';